$( ->
  $('.sort-owner').on 'cocoon:after-insert', (e, child_item)->
    if child_item.find('textarea.tinymce').length > 0
      next_id = $(this).find('textarea.tinymce').length + 1
      the_ta = child_item.find('textarea.tinymce').first()
      the_ta.attr 'id', the_ta.attr('id') + '_' + next_id
      tinymce.execCommand 'mceAddEditor', false, the_ta.attr('id')
)
